
import {
  FREQUENCY_SLIDER_VALUES,
  campaignFrequencies,
  campaignSliderFrequencies,
} from '@/statics/campaign-wizard';
import { CampaignFrequency, FREQUENCY, FrequencyUserType } from '@/types/campaigns';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { LocationData } from '@/types/locations';
import { isAllSelectedLocationsPriceControlByShasha } from '@/utils/campaigns';
import { fetchCampaignDefaultFrequencyConfigByUserRole } from '@/actions/campaigns/actions';
import { USER_ROLES } from '@/statics/user-roles';
import { formatCurrency, toNumberOr } from '@/utils/numbers';
import { TimeSlotSelection } from '@/types/time-slots';
import { getLocationPriceByFrequency } from '@/utils/locations';

@Component({
  components: {},
})
export default class TimeSelection extends Vue {
  @Prop({ type: Object }) frequency!: CampaignFrequency;

  @Getter('selectedLocations', { namespace: namespaces.CampaignWizardModule })
  public selectedLocations!: LocationData[];

  @Getter('time', { namespace: namespaces.CampaignWizardModule })
  public campaignWizardSelectedTimeSlots!: TimeSlotSelection;

  public frequencies = campaignFrequencies;
  public timeFrequenciesInMinutes: number[] = [];
  public isLoading = false;
  public defaultFrequency!:FREQUENCY;

  public get sliderValue() {
    return FREQUENCY_SLIDER_VALUES[this.frequency?.NAME];
  }

  public set sliderValue(sliderValue: number) {
    const selectedFrequency = campaignSliderFrequencies[sliderValue];
    this.$emit('update:frequency', selectedFrequency);
  }

  log(data:any){
    console.log(data)
  }
  get isAllSelectedLocationsPriceControlByShasha() {
    return isAllSelectedLocationsPriceControlByShasha(this.selectedLocations);
  }
  public async mounted() {
    try {
      this.isLoading = true;
      const {
        enforcedFrequency,
        defaultFrequency
      } = await fetchCampaignDefaultFrequencyConfigByUserRole(USER_ROLES.ADVERTISER.VAL as FrequencyUserType)
      this.defaultFrequency = defaultFrequency;
      if (!this.campaignWizardSelectedTimeSlots?.frequency) {
        const frequencyKey = this.isAllSelectedLocationsPriceControlByShasha
            ? defaultFrequency
            : enforcedFrequency;

        this.sliderValue = FREQUENCY_SLIDER_VALUES[frequencyKey];
      }

      this.timeFrequenciesInMinutes = Object.values(this.frequencies).map(({ MINUTES }) => MINUTES);
    }
    finally {
      this.isLoading = false;
    }
  }

  @Watch('frequency')
  highlightSelectedFrequency() {
    const selectedFrequency = document.querySelector('.selected-frequency-minutes');
    if (selectedFrequency) {
      selectedFrequency.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  @Watch('$vuetify.rtl')
  localeChanged() {
    if(this.isAllSelectedLocationsPriceControlByShasha){
      const div = this.$el.querySelector('#default-choice');
      if (div) {
        div.textContent = this.$t('default_choice').toString();
      }
    }
  }
  public get duration(){
    return this.campaignWizardSelectedTimeSlots.duration
  }
  public get frequencyOptions() {
    try {
      const {
        duration,
      } = this.campaignWizardSelectedTimeSlots;
      const allFrequencies = Object.values(campaignFrequencies);
      const locationPrices = this.selectedLocations.reduce((allSelectedLocations, selectedLocation: LocationData) => {
        const allFrequenciesPricesForLocation = allFrequencies.reduce((allFrequenciesMap, frequencyItem) => ({
          ...allFrequenciesMap,
          [frequencyItem.NAME]: getLocationPriceByFrequency(selectedLocation, frequencyItem) * toNumberOr(duration, 0)
        }), {} as Record<CampaignFrequency['NAME'], Exclude<LocationData['BASE_PRICE'], undefined>>)
        return {
          ...allSelectedLocations,
          [selectedLocation.clusterId]: {
            ...allFrequenciesPricesForLocation
          }
        }
      }, {} as Record<LocationData['clusterId'], Record<CampaignFrequency['NAME'], Exclude<LocationData['BASE_PRICE'], undefined>>>);
      return Object.values(campaignFrequencies).map((frequency, sliderValue) => {
        const totalPrice = Object.values(locationPrices).reduce((total, locationPrice) => {
          return total + locationPrice[frequency.NAME]
        }, 0)
        return {
          value: sliderValue,
          frequency,
          totalPrice,
        }
      })
    } catch (e) {
      console.log(e)
    }

  }
}
